import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';

const response = {
    async postFetchProfiles(payload: any): Promise<any> {
        return await api(
            HTTP_TYPES.POST,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/fetch-profiles`,
            payload
        );
    },
    async getFetchResponseProfile(profile_uuid: any): Promise<any> {
        // profile_uuid: guid

        return await api(
            HTTP_TYPES.GET,
            `${import.meta.env.VITE_DEPOT_API_REVIEWS}/fetch-profiles/${profile_uuid}`
        );
    }
};

export default response;
